import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWall2Left: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-wall-2-left, align left"><path d="M9.5 7.75L5.25 12L9.5 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 12L6 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowWall2Left;
